import React, { useState } from "react";
import { clientData } from "../data/clientData";
import { RxCross2 } from "react-icons/rx";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import toast from "react-hot-toast";

const Client = () => {
  const [data, setData] = useState(clientData);
  const [menuOpen, setMenuOpen] = useState(false);
  const [name,setName] = useState('');
  const [company,setCompany] = useState('');
  const [email,setEmail] = useState('');
  const [phone,setPhone] = useState('');
  const [location,setLocation] = useState('');
  const [editId,setEditId] = useState(null);
  const [submitted,setSumbitted] = useState(false);

  const handleSubmit = () =>{
  setSumbitted(true);
  if(!name || !company || !email || !phone || !location){
    toast.error('Please Fill All Fields');
     return
  }
    if(editId){
    const updateItem = data.map((item) =>(item.id === editId)?{...item,name,company,email,phone,location}:item)
     toast.success('Employee Edit Successfully')
    console.log(updateItem)
    setData(updateItem)
    }
    else{
        const newData = {id:data.length +1, name,company,email,phone,location}
         toast.success('Employee Add Successfully')
    console.log(newData)
    setData([...data,newData])
    }
 
    setName('');
    setCompany('');
    setEmail('');
    setPhone('');
    setLocation('');
    setEditId('');
    setMenuOpen(false);
    setSumbitted(false);
  }

  const handleEdit = (data) =>{
    setEditId(data.id)
    setName(data.name);
    setCompany(data.company);
    setEmail(data.email);
    setPhone(data.phone);
    setLocation(data.location)
    setMenuOpen(true);
  }


  const handleDelete = (id) =>{
   const deleteItem = data.filter((item) =>(item.id !== id))
    toast.success('Employee Delete Successfully')
   setData(deleteItem)
   console.log(deleteItem)
  }
  return (
    <div className=" mt-[10%] md:mt-[4%] px-5">
      <div className="  flex justify-end">
        <button className=" px-4 py-2 rounded-md text-primary bg-third text-sm"  onClick={() => setMenuOpen(!menuOpen)}>
          Add
        </button>
      </div>
      <div>
        <table className=" w-full mt-5">
          <thead>
            <tr>
              {[
                "S.No",
                "Name",
                "Company Name",
                "Email",
                "Phone",
                "Location",
                "Action"
              ].map((col, i) => (
                <th
                  key={i}
                  className=" border-b  font-bold px-4 py-4 text-left text-primary text-nowrap"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((cli, i) => (
              <tr key={i} className=" hover:bg-third  cursor-pointer">
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {i + 1}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {cli.name}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {cli.company}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {cli.email}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {cli.phone}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {cli.location}
                </td>
                 <td className=" border-b text-sm font-medium px-4 py-4 text-left flex gap-3">
                 <button><CiEdit fontSize={25}  onClick={() => handleEdit(cli)} /></button>
                 <button><MdDeleteOutline fontSize={25} onClick={() =>handleDelete(cli.id)}/></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {menuOpen && (
          <div className=" flex justify-end items-center bg-black bg-opacity-20 inset-0 fixed z-20 mt-10 ">
            <div className=" bg-white p-6  w-96 rounded-md h-screen ">
              <div className=" flex justify-between mt-5">
                <h4 className=" font-bold text-primary text-xl">
                  Client Detail
                </h4>
                <button
                  className=" hover:text-primary "
                  onClick={() => setMenuOpen(false)}
                >
                  <RxCross2 fontSize={20} />
                </button>
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Name:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter name"
                  value={name}
                  onChange={(e) =>setName (e.target.value)}
                />
                 {submitted && (
                                          <p className=" text-xs font-medium text-red-500">Name is required</p>
                                        )}
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Company Name:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter Company Name"
                  value={company}
                  onChange={(e) =>setCompany(e.target.value)}
                  />
            {submitted && (
                                          <p className=" text-xs font-medium text-red-500">Company Name is required</p>
                                        )} 
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Email :</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                placeholder="Enter Email"
                value={email}
                onChange={(e) =>setEmail(e.target.value)}
                />
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Phone:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="number"
                  placeholder="Enter Phone"
                  value={phone}
                  onChange={(e) =>setPhone(e.target.value)}
                />
                 {submitted && (
                                          <p className=" text-xs font-medium text-red-500">phone is required</p>
                                        )}
              </div>

               <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Location:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter location "
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
                 {submitted && (
                                          <p className=" text-xs font-medium text-red-500">location is required</p>
                                        )}
              </div>

              <div className=" mt-5">
                <button className=" bg-primary w-full px-4 py-2 rounded-md text-white text-sm font-semibold" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Client;
